import { render } from "./Noticias.vue?vue&type=template&id=454fb31b&scoped=true"
const script = {}

import "./Noticias.vue?vue&type=style&index=0&id=454fb31b&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454fb31b"]])

export default __exports__